import { axios } from 'services/axios';

/**
 * Fetches the full 8x8 service profile for a wholesaler or partner.
 *
 * Wholesaler — GET /ServiceProfile/EightByEight/Wholesaler/{wholesalerID}  (X-RequestScope: 80)
 * Partner    — GET /ServiceProfile/EightByEight/Partner/{partnerID}
 *
 * @param {{ level: string, wholesalerID?: string, partnerID?: string }} params
 */
const getEightByEightServiceProfile = async ({
    level,
    wholesalerID,
    partnerID,
}) => {
    if (level === 'partner') {
        const res = await axios.get(
            `/ServiceProfile/EightByEight/Partner/${partnerID}`,
            { _requestScopeOverride: 60 },
        );
        return res.data;
    }
    const res = await axios.get(
        `/ServiceProfile/EightByEight/Wholesaler/${wholesalerID}`,
        { _requestScopeOverride: 80 },
    );
    return res.data;
};

export { getEightByEightServiceProfile };
